import styled from 'styled-components'

const info = require('src/assets/wizard/info_i.png')

export const MoreInfo = styled.div`
  position: absolute;
  right: 15px;
  bottom: 15px;
  width: 27px;
  height: 27px;
  padding: 2px;
  background-image: url(${info});
  background-size: cover;
  background-position: center;
  background-color: #9abbbf;
  border: 2px solid #9abbbf;
  border-radius: 100%;
  cursor: pointer;
`

export default MoreInfo



// WEBPACK FOOTER //
// ./src/components/atoms/input/buttons/MoreInfo.tsx